import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import {MatListModule} from '@angular/material/list';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { DeployInstanceModule } from '../service/deploy-instance/deploy-instance.module';
import { ReportIssueModule } from '../service/report-issue/report-issue.module';
import { ViewEndpointsModule } from '../service/view-endpoints/view-endpoints.module';
import { ViewUpdateResultsModule } from '../service/view-update-results/view-update-results.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { PageLoaderModule } from 'src/app/components/page-loader/page-loader.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TableModule } from 'src/app/table/table.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InstanceDetailsModule } from 'src/app/components/instance-details/instance-details.module';
import { TenantDisasterRecoveryComponent } from './tenant-disaster-recovery.component';
import { TenantDisasterRecoveryRoutingModule } from './tenant-disaster-recovery-routing.module';
import { DisasterRecoveryInstancesComponent } from './disaster-recovery-instances/disaster-recovery-instances.component';
import { ViewInstanceDetailsComponent } from './view-instance-details/view-instance-details.component';
import {SearchFilterModule} from '../../components/search-filter/search-filter.module';
import { MatDialogModule } from '@angular/material/dialog';
import { DrModeDialogComponent } from 'src/app/components/dr-mode-dialog/dr-mode-dialog.component';

@NgModule({
  declarations: [
    TenantDisasterRecoveryComponent,
    DisasterRecoveryInstancesComponent,
    ViewInstanceDetailsComponent,
    DrModeDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    TenantDisasterRecoveryRoutingModule,
    BreadcrumbModule,
    MatListModule,
    NgxSkeletonLoaderModule,
    MatExpansionModule,
    MatDividerModule,
    DeployInstanceModule,
    ReportIssueModule,
    ViewEndpointsModule,
    ViewUpdateResultsModule,
    PipesModule,
    PageLoaderModule,
    MatTabsModule,
    MatTooltipModule,
    TableModule,
    PaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    InstanceDetailsModule,
    SearchFilterModule,
    MatDialogModule
  ]
})
export class TenantDisasterRecoveryModule { }
